<div class="filter-dropdown" #root>
  <button
    #triggerButton
    type="button"
    class="dropdown-trigger"
    [class.dropdown-trigger-open]="isOpen"
    [class.dropdown-trigger-invalid]="invalid"
    [disabled]="disabled"
    (click)="toggleOpen()"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="isOpen ? panelId : null"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabel ? null : triggerLabelId"
    [attr.aria-describedby]="ariaDescribedBy"
    [attr.aria-invalid]="invalid ? 'true' : null"
    aria-haspopup="dialog"
  >
    <div class="trigger-left">
      <mat-icon *ngIf="iconSvg" [svgIcon]="iconSvg" class="trigger-icon" aria-hidden="true"></mat-icon>

      <div class="trigger-copy">
        <div class="trigger-label" [attr.id]="triggerLabelId">{{ label }}</div>
        <div class="trigger-value" [class.trigger-value-dim]="dimValue">{{ valueText }}</div>
      </div>
    </div>

    <span class="trigger-arrow" aria-hidden="true"></span>
  </button>

  <div
    *ngIf="isOpen && usesDateBackdrop"
    class="cdk-overlay-backdrop cdk-overlay-transparent-backdrop cdk-overlay-backdrop-showing"
    (click)="onBackdropClick()"
  ></div>

  <div
    #panel
    class="dropdown-panel"
    [class.dropdown-panel-open-above]="openAbove"
    *ngIf="isOpen"
    [attr.id]="panelId"
    role="dialog"
    aria-modal="false"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabel ? null : triggerLabelId"
    [style.width.px]="panelWidth"
    [ngClass]="panelClass"
    animate.enter="filter-dropdown-enter"
    animate.leave="filter-dropdown-leave"
  >
    <ng-content></ng-content>
  </div>
</div>
